// 引入路由
import router from '../router';

/**
 * 时间戳
 * @param {*} timestamp  时间戳
 */
const timestampToTime = (timestamp) => {
    let date = new Date(timestamp) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    let Y = date.getFullYear() + '-'
    let M =
        (date.getMonth() + 1 < 10 ?
            '0' + (date.getMonth() + 1) :
            date.getMonth() + 1) + '-'
    let D =
        (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
    let h =
        (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
    let m =
        (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) +
        ':'
    let s =
        date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
    return Y + M + D + h + m + s
};
/**
 * 存储localStorage
 */
const setStore = (name, content) => {
    if (!name) return;
    if (typeof content !== 'string') {
        content = JSON.stringify(content);
    }
    window.localStorage.setItem(name, content);
}

/**
 * 获取localStorage
 */
const getStore = name => {
    if (!name) return;
    return window.localStorage.getItem(name);
}

/**
 * 删除localStorage
 */
const removeStore = name => {
    if (!name) return;
    window.localStorage.removeItem(name);
}

/**
 * 设置cookie
 **/
function setCookie(name, value, day) {
    let date = new Date();
    date.setDate(date.getDate() + day);
    document.cookie = name + '=' + value + ';expires=' + date;
};

/**
 * 获取cookie
 **/
function getCookie(name) {
    let reg = RegExp(name + '=([^;]+)');
    let arr = document.cookie.match(reg);
    if (arr) {
        return arr[1];
    } else {
        return '';
    }
};

/**
 * 校验登陆状态code
 **/
function checkLogin(data) {
    if(data.code == 4000 || data.code == 4001){
        console.log('登陆已失效,清除登陆状态!')
        // 登陆已失效 清除登陆状态
        setTimeout(() => {
            // this.$message({
            //     type: 'error',
            //     message: '登陆已过期，请重新登陆!'
            // })
            window.localStorage.removeItem('logout');
            window.localStorage.removeItem('logintoken');
            window.localStorage.removeItem('userInfo');
            window.localStorage.removeItem('userdata');
            router.push({ path: '/login' })
            // location.reload();
            }, 1000)
    }else{
        return data;
    }
};

/**
 * 删除cookie
 **/
function delCookie(name) {
    setCookie(name, null, -1);
};

/**
 * 获取当前年月,例如:202012
 */
function getCurrentDate(){
    const date = new Date()
    let monthStr = ''
    let timeStr = ''
    console.log(date)
    const year = date.getFullYear()
    const month = date.getMonth() + 1
    const time = date.getDate()
    if(month < 10){
        monthStr  = '0'+ month
    }else{
        monthStr = month
    }
    if(time < 10){
        timeStr  = '0'+ time
    }else{
        timeStr = time
    }
    return year+'-'+monthStr+'-'+timeStr
}

/**
 * 导出 
 **/
export {
    timestampToTime,
    setStore,
    getStore,
    removeStore,
    setCookie,
    getCookie,
    delCookie,
    checkLogin,
    getCurrentDate
}


// WEBPACK FOOTER //
// ./src/utils/util.js